import { useState } from "react";
import ee from "../../assets/Icon/Logo.png";

function Home() {
  const [Size] = useState(window.innerHeight - 200);
  return (
    <div className={"stateLoading"}>
      <div
        className="d-flex justify-content-center align-items-center element"
        style={{ height: Size }}
      >
        <img className="w-25" src={ee} />
      </div>
    </div>
  );
}

export default Home;
